"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBBusinessDomain", {
  enumerable: true,
  get: function get() {
    return _SVBBusinessDomain.default;
  }
});
var _SVBBusinessDomain = _interopRequireDefault(require("./src/SVBBusinessDomain"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }